import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/domain";
import DomainPublicSchema from "@common/schema/domain/public";
import OrganizationPublicSchema from "@common/schema/organization/public";
import KeysPublicSchema from "@common/schema/keys/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";
import * as OrganizationsRoute from "./organizations";
import * as KeysRoute from "./keys";

const LocalProvider = ({
  match: {
    params,
    params: { domain },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${domain}`;
  const basepath = `${parentBasepath}/:domain`;

  // Keyed on the entity, which is what the accidental remount used to do.
  //
  // Every screen below seeds its form state ONCE, from the entity this
  // route resolved. Until the render prop above was called rather than
  // rendered, React saw a new component type on every render and remounted
  // the lot — which reset those forms, and happened to be what made moving
  // from one domain to another show the new one's values. It no longer
  // remounts for free, so the reset it was providing is asked for here.
  return (
    <Section.Provider
      key={domain}
      schema={[...DomainPublicSchema, ...OrganizationPublicSchema, ...KeysPublicSchema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"domains.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/organization`} component={OrganizationsRoute.Content} />
      <Route path={`${basepath}/key`} component={KeysRoute.Content} />
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { domain } }) => (
        <>
          <Crumb to={`${base}`} label={domain} />

          <Switch>
            <Route path={`${basepath}/organization`} component={OrganizationsRoute.Indice} />
            <Route path={`${basepath}/key`} component={KeysRoute.Indice} />
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <EditRoute.Sidebar />
    <ViewRoute.Sidebar />
  </>
);
